module.exports = __webpack_public_path__ + "img/flag_nl.6e0a056a.svg";